var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.32812C0 6.18229 0.0520833 6.05729 0.15625 5.95312C0.260417 5.84896 0.382812 5.79688 0.523438 5.79688H5.80469V0.523438C5.80469 0.382812 5.85417 0.260417 5.95312 0.15625C6.05729 0.0520833 6.18229 0 6.32812 0C6.47396 0 6.59896 0.0520833 6.70312 0.15625C6.80729 0.260417 6.85938 0.382812 6.85938 0.523438V5.79688H12.125C12.2708 5.79688 12.3958 5.84896 12.5 5.95312C12.6042 6.05729 12.6562 6.18229 12.6562 6.32812C12.6562 6.47396 12.6042 6.59896 12.5 6.70312C12.3958 6.80208 12.2708 6.85156 12.125 6.85156H6.85938V12.1328C6.85938 12.2734 6.80729 12.3958 6.70312 12.5C6.59896 12.6042 6.47396 12.6562 6.32812 12.6562C6.18229 12.6562 6.05729 12.6042 5.95312 12.5C5.85417 12.3958 5.80469 12.2734 5.80469 12.1328V6.85156H0.523438C0.382812 6.85156 0.260417 6.80208 0.15625 6.70312C0.0520833 6.59896 0 6.47396 0 6.32812Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7f1decbf.svg";
export { ForwardRef as ReactComponent };